import { Grid, Typography } from "@mui/material"
import React from "react"
import styles from "./CategoryStyle.module.scss"
import { useSelector } from "react-redux"

const CategoryCard = ({ title, category, count }) => {
  const categorySelected = useSelector((store) => store?.app?.filters?.category || [])
  const isIncluded =
    title === "Special"
      ? categorySelected.includes("specials")
      : categorySelected.includes(title.toLowerCase())

  return (
    <div style={{ position: "relative", display: "flex" }}>
      <Grid item className={`${styles.container} ${isIncluded && styles.withBoxShadow}`}>
        <Typography variant="body1Regular" color="text.secondary" sx={{ padding: "4px 16px" }}>
          {title === "Vip" ? "VIP" : title}
        </Typography>
        {category !== "ALL" && (
          <Grid container className={styles.cat_container}>
            <Typography variant="emphasisText" color="white.main" letterSpacing="normal">
              {category}
            </Typography>
          </Grid>
        )}
        <Grid item className={styles.ellipse_spirit_gold}>
          {count ?? 0}
        </Grid>
      </Grid>
    </div>
  )
}

export default CategoryCard
